export const breakpoints = [320, 640, 768, 1024, 1280, 1536];
export function isStoryblokImage(url) {
    if (!url) {
        return false;
    }
    return url.includes('a.storyblok.com');
}
export function isBunnyCDNImage(url) {
    if (!url) {
        return false;
    }
    return url.includes('b-cdn.net');
}
export function formatStoryblokImage(url, w, height) {
    return `${url}/m/${w}x${height || 0}`;
}
export function formatBunnyCDNImage(url, w, height, fit) {
    const params = [];
    if (height) {
        // If both width and height are specified, use crop
        params.push(`aspect_ratio=${w}:${height}`);
        params.push(`width=${w}`);
    }
    else {
        // If only width is specified, use width
        params.push(`width=${w}`);
    }
    if (fit)
        params.push(`fit=${fit}`);
    return `${url}?${params.join('&')}`;
}
export function calculateSizes(width, sizes) {
    if (sizes)
        return sizes;
    return breakpoints.map((bp, index) => {
        const nextBp = breakpoints[index + 1];
        if (nextBp) {
            return `(max-width: ${nextBp}px) ${Math.min(width, bp)}px`;
        }
        return `${width}px`;
    }).join(', ') + `, ${width * 2}px 2x`;
}
export function generateSrcSet(src, width, height, fit) {
    const retinaWidth = width * 2;
    const sizes = [
        ...new Set([
            ...breakpoints.filter(w => w <= retinaWidth),
            width,
            retinaWidth
        ])
    ].sort((a, b) => a - b);
    return sizes
        .map(w => {
        let url;
        if (isStoryblokImage(src)) {
            url = formatStoryblokImage(src, w, height ? Math.round(height * w / width) : undefined);
        }
        else if (isBunnyCDNImage(src)) {
            url = formatBunnyCDNImage(src, w, height ? Math.round(height * w / width) : undefined, fit);
        }
        else {
            url = src;
        }
        return `${url} ${w}w`;
    })
        .join(', ');
}
export function generateFormattedSrc(src, width, height, fit) {
    if (isStoryblokImage(src)) {
        return formatStoryblokImage(src, width || breakpoints[breakpoints.length - 1], height);
    }
    else if (isBunnyCDNImage(src)) {
        return formatBunnyCDNImage(src, width || breakpoints[breakpoints.length - 1], height, fit);
    }
    return src;
}
